export default {
  labels: {
    today: 'Today',
    date: 'Date',
    time: 'Time',
  },
  feedback: {
    selected_time_invalid: 'Sorry, but selected date or time is not available. Please change the order time',
  },
};
